import styled from "styled-components";
import * as Variable from "../../CSSVariables";

export const GlobalNavStyle = styled.div`
  z-index: 1;
  position: relative;
  background-color: ${Variable.black};
  padding: 10px;
  img {
    width: 145px;
    height: 30px;
  }
  p {
    color: ${Variable.white};
    margin: 0;
  }
`;
